import type { StudyImageExportTarget } from './types';

const NON_IMAGE_MODALITIES = ['SR', 'SEG', 'RTSTRUCT', 'RTPLAN', 'RTDOSE', 'DOC', 'PMAP'];

export function collectStudyImageExportTargets(
  studyInstanceUID: string,
  servicesManager: AppTypes.ServicesManager,
  extensionManager: AppTypes.ExtensionManager
): StudyImageExportTarget[] {
  const { displaySetService } = servicesManager.services;
  const [dataSource] = extensionManager.getActiveDataSource();

  if (!dataSource?.getImageIdsForDisplaySet) {
    return [];
  }

  const displaySets = displaySetService.activeDisplaySets.filter(displaySet => {
    return (
      displaySet.StudyInstanceUID === studyInstanceUID &&
      !displaySet.excludeFromThumbnailBrowser &&
      !displaySet.unsupported &&
      !NON_IMAGE_MODALITIES.includes(displaySet.Modality)
    );
  });

  const targets: StudyImageExportTarget[] = [];
  let exportIndex = 0;

  displaySets.forEach(displaySet => {
    const imageIds = dataSource.getImageIdsForDisplaySet(displaySet) || [];

    imageIds.forEach((imageId: string, sliceIndex: number) => {
      if (!imageId) {
        return;
      }

      exportIndex += 1;
      targets.push({
        imageId,
        seriesNumber: displaySet.SeriesNumber,
        instanceNumber: sliceIndex + 1,
        exportIndex,
      });
    });
  });

  return targets;
}
